"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CharacterRobotOutlineIcon = void 0;
var React = __importStar(require("react"));
function CharacterRobotOutlineIcon(props) {
  var _a, _b, _c, _d;
  return React.createElement("svg", __assign({
    width: (_a = props.width) !== null && _a !== void 0 ? _a : 24,
    height: (_b = props.height) !== null && _b !== void 0 ? _b : 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: (_c = props.fill) !== null && _c !== void 0 ? _c : "#191C22",
    viewBox: (_d = props.viewBox) !== null && _d !== void 0 ? _d : "0 0 24 24"
  }, props), React.createElement("g", {
    clipPath: "url(#a)"
  }, React.createElement("path", {
    d: "M9.101 11.9h-2.2v2.2h2.2v-2.2ZM17.101 11.9h-2.2v2.2h2.2v-2.2ZM14.001 17h-4v2h4v-2Z"
  }), React.createElement("path", {
    d: "M21.001 11v-1a3 3 0 0 0-3-3h-5V5.816a2.992 2.992 0 0 0-1-5.816 2.992 2.992 0 0 0-1 5.816V7h-5a3 3 0 0 0-3 3v1a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3v1a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-1a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3Zm-9-9c.552.001.999.448 1 1a1.002 1.002 0 0 1-1 1 1.002 1.002 0 0 1-1-1 1.002 1.002 0 0 1 1-1Zm-10 14v-2a1.002 1.002 0 0 1 1-1v4a1.002 1.002 0 0 1-1-1Zm17 4a1.002 1.002 0 0 1-1 1h-12a1.002 1.002 0 0 1-1-1V10a1.002 1.002 0 0 1 1-1h12c.552.001.999.448 1 1v10Zm3-4a1.002 1.002 0 0 1-1 1v-4c.552.001.999.448 1 1v2Z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    transform: "translate(.001)",
    d: "M0 0h24v24H0z"
  }))));
}
exports.CharacterRobotOutlineIcon = CharacterRobotOutlineIcon;